"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerManager = void 0;

var _fastMemoize = _interopRequireDefault(require("fast-memoize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* ========================================================================== */
var ContainerManager = /*#__PURE__*/function () {
  function ContainerManager() {
    var _this = this;

    var containerMapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getKey = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, ContainerManager);

    _defineProperty(this, "getInstance", (0, _fastMemoize["default"])(function (key) {
      return new _this.containerMapping[key]();
    }));

    this.containerMapping = containerMapping;
    this.getKey = getKey;
  }

  _createClass(ContainerManager, [{
    key: "getContainer",
    value: function getContainer() {
      var getKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getKey;

      if (typeof getKey !== "string" && typeof getKey !== "function") {
        throw new TypeError("getContainer did not get a valid 'getKey' specified. Expected string or function, received ".concat(_typeof(getKey), "."));
      }

      return this.getInstance(typeof getKey === "string" ? getKey : getKey());
    }
  }]);

  return ContainerManager;
}();

exports.ContainerManager = ContainerManager;